// extracted by mini-css-extract-plugin
module.exports = {"topBlock":"TopBlock_topBlock__37PhA","blockHeader":"TopBlock_blockHeader__2HjAH","tabs":"TopBlock_tabs__3lhY4"};